import React from 'react';
import useCounterHook from './Counter.hook';
import { ReactComponent as MinusIcon } from 'assets/images/minus-icon.svg';
import { ReactComponent as PlusIcon } from 'assets/images/plus-icon.svg';

import './Counter.css';

export default function Counter({ value, min, max, onChange }) {
  const { state, actions } = useCounterHook({ value, min, max, onChange });
  return (
    <div className="counter-container">
      <div className="button-box" onClick={actions.decrement}>
        <MinusIcon />
      </div>
      <span className={`counter-value ${state.count === 0 && 'zero-value'}`}>{state.count}</span>
      <div className="button-box" onClick={actions.increment}>
        <PlusIcon />
      </div>
    </div>
  );
}
